import { Mutation } from '@/generated/graphql';
import { ApolloClient, gql } from '@apollo/client/core';

type ResendMutationResponse = {
  errors?: string[];
};

const RESEND_INVITE = gql`
  mutation sendUserAccountInvitation($userAccountId: Int!) {
    app {
      sendUserAccountInvitation(input: {userAccountId: $userAccountId}) {
        errors
      }
    }
  }
`;

export const resendInvite = async (client: ApolloClient<Mutation>, userAccountId: number): Promise<ResendMutationResponse> => {
  const { data } = await client.mutate<Mutation>({
    mutation: RESEND_INVITE,
    variables: { userAccountId },
    fetchPolicy: 'network-only',
  });

  if (data?.app?.sendUserAccountInvitation?.errors) {
    return { errors: data?.app?.sendUserAccountInvitation?.errors };
  }
  return {};
};
